module.exports = __webpack_public_path__ + "static/emma-5253e7f86be79e9382a3c17795d53cf3.svg";